import { createContext } from "react";
import type { TenantResolutionError } from "@/lib/tenant-resolver";

export interface MfaSetupData {
  secretCode: string;
  qrUri: string;
}

export interface AuthContextValue {
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  completeNewPassword: (newPassword: string) => Promise<void>;
  forgotPassword: (email: string) => Promise<void>;
  confirmForgotPassword: (
    email: string,
    code: string,
    newPassword: string,
  ) => Promise<void>;
  confirmMfaCode: (code: string) => Promise<void>;
  confirmMfaSetup: (code: string) => Promise<void>;
  mfaSetupData: MfaSetupData | null;
  tenantError: TenantResolutionError | null;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
